<template>
	<div class="users">
		<a-form-model :model="setting" :rules="rules" layout="vertical" @submit="save_data" ref="setting_form"
			style="width:500px;">
			<a-divider orientation="left">
				基础配置
			</a-divider>

			<a-form-model-item ref="fx_url" prop="fx_url" label="首页学习业务网址">
				<a-input v-model="setting.fx_url" placeholder="请输入首页学习业务网址" />
			</a-form-model-item>

			<a-form-model-item ref="edu_url" prop="edu_url" label="个人中心学习网址">
				<a-input v-model="setting.edu_url" placeholder="请输入个人中心学习网址" />
			</a-form-model-item>


			<a-form-model-item ref="xj_url1" prop="xj_url1" label="询价电池类型疑问网址">
				<a-input v-model="setting.xj_url1" placeholder="请输入询价电池类型疑问网址" />
			</a-form-model-item>
			<a-form-model-item ref="xj_url2" prop="xj_url2" label="询价总千瓦时疑问网址">
				<a-input v-model="setting.xj_url2" placeholder="请输入询价总千瓦时疑问网址" />
			</a-form-model-item>


			<a-form-model-item ref="ref_exptime" prop="ref_exptime" label="邀请码填写超时时间(h)">
				<a-input-number v-model="setting.ref_exptime" style="width:200px;" placeholder="请输入邀请码填写超时时间" />
			</a-form-model-item>
			<a-form-model-item ref="phone" prop="phone" label="客服电话">
				<a-input v-model="setting.phone" placeholder="请输入客服电话" />
			</a-form-model-item>
			<a-form-model-item ref="email" prop="email" label="联系邮箱">
				<a-input v-model="setting.email" placeholder="请输入联系邮箱" />
			</a-form-model-item>
			<a-form-model-item ref="sms_phone" prop="sms_phone" label="公共接收短信手机号">
				<a-input v-model="setting.sms_phone" placeholder="请输入公共接收短信手机号" />
			</a-form-model-item>
			<a-divider orientation="left">
				协议政策
			</a-divider>
			<a-form-model-item ref="service" prop="service" label="服务协议" style="width:800px;">
				<AEditor v-model="setting.service" />
			</a-form-model-item>
			<a-form-model-item ref="yinsi" prop="yinsi" label="隐私政策" style="width:800px;">
				<AEditor v-model="setting.yinsi" />
			</a-form-model-item>
			<a-form-model-item ref="car_gj_img" prop="car_gj_img" label="估价结果案例" style="width:800px;">
				<AEditor v-model="setting.car_gj_img" />
			</a-form-model-item>
			<a-form-model-item ref="car_sel_img" prop="car_sel_img" label="资料结果案例" style="width:800px;">
				<AEditor v-model="setting.car_sel_img" />
			</a-form-model-item>
			<a-form-model-item ref="car_type_img" prop="car_type_img" label="车型帮助说明" style="width:800px;">
				<AEditor v-model="setting.car_type_img" />
			</a-form-model-item>
			<a-form-model-item ref="car_share_info" prop="car_share_info" label="分享规则说明" style="width:800px;">
				<AEditor v-model="setting.car_share_info" />
			</a-form-model-item>
			<a-form-model-item ref="car_address_img" prop="car_address_img" label="服务网点案例" style="width:800px;">
				<AEditor v-model="setting.car_address_img" />
			</a-form-model-item>
			<a-divider orientation="left">
				小程序配置
			</a-divider>
			<a-form-model-item ref="wx_appid" prop="wx_appid" label="小程序APPID">
				<a-input v-model="setting.wx_appid" placeholder="请输入小程序APPID" />
			</a-form-model-item>
			<a-form-model-item ref="wx_appsecret" prop="wx_appsecret" label="小程序APPSECRET">
				<a-input v-model="setting.wx_appsecret" placeholder="请输入小程序APPSECRET" />
			</a-form-model-item>
			<a-form-model-item ref="lithium_top_banner" label="锂电市场宣传图">
				<div style="display:flex; align-items:center; gap:12px;">
					<div v-if="banner_preview" style="position:relative; width:240px; height:96px; border:1px solid #d9d9d9; border-radius:4px; overflow:hidden; background:#fafafa;">
						<img :src="banner_preview" style="width:100%; height:100%; object-fit:cover;" />
						<a-icon type="close" @click="remove_banner" style="position:absolute; top:0; right:0; width:20px; height:20px; line-height:20px; text-align:center; background:rgba(0,0,0,.55); color:#fff; cursor:pointer;" />
					</div>
					<a-upload
						v-else
						:show-upload-list="false"
						:custom-request="banner_upload"
						accept="image/*"
					>
						<a-button><a-icon type="upload" /> 上传图片</a-button>
					</a-upload>
					<span style="color:#999; font-size:12px;">小程序锂电市场顶部宣传图</span>
				</div>
			</a-form-model-item>
			<a-divider orientation="left">
				订阅消息模板配置
			</a-divider>
			<a-form-model-item ref="wx_tmpl_bid" prop="wx_tmpl_bid" label="市场信息订阅消息模板ID">
				<a-input v-model="setting.wx_tmpl_bid" placeholder="首页市场信息新发布推送模板ID" />
			</a-form-model-item>
			<a-form-model-item ref="wx_tmpl_market" prop="wx_tmpl_market" label="锂电行情订阅消息模板ID">
				<a-input v-model="setting.wx_tmpl_market" placeholder="锂电行情价格变更推送模板ID" />
			</a-form-model-item>
			<a-form-model-item ref="wx_tmpl_lithium" prop="wx_tmpl_lithium" label="锂电市场订阅消息模板ID">
				<a-input v-model="setting.wx_tmpl_lithium" placeholder="锂电市场新产品推送模板ID" />
			</a-form-model-item>
			<a-divider orientation="left">
				APP推送(uni-push 1.0 个推)
			</a-divider>
			<a-form-model-item ref="getui_app_id" prop="getui_app_id" label="个推AppID">
				<a-input v-model="setting.getui_app_id" placeholder="开发者中心 → uni-push → 1.0（老版本）→ 消息推送 → 应用配置" />
			</a-form-model-item>
			<a-form-model-item ref="getui_app_key" prop="getui_app_key" label="个推AppKey">
				<a-input v-model="setting.getui_app_key" placeholder="个推鉴权 appkey" />
			</a-form-model-item>
			<a-form-model-item ref="getui_master_secret" prop="getui_master_secret" label="个推MasterSecret">
				<a-input v-model="setting.getui_master_secret" placeholder="个推鉴权 mastersecret（敏感信息，勿外泄）" />
			</a-form-model-item>
			<a-form-model-item ref="getui_android_packagename" prop="getui_android_packagename" label="APP应用包名(Android)">
				<a-input v-model="setting.getui_android_packagename" placeholder="如 com.xxx.ldb，厂商通道点击直达详情页；留空则点击仅打开应用" />
			</a-form-model-item>
			<a-divider orientation="left">
				阿里云认证配置
			</a-divider>
			<a-form-model-item ref="ali_appcode" prop="ali_appcode" label="阿里云APPCODE">
				<a-input v-model="setting.ali_appcode" placeholder="请输入阿里云APPCODE" />
			</a-form-model-item>
			<a-divider orientation="left">
				短信配置
			</a-divider>
			<a-form-model-item ref="ali_appkey" prop="ali_appkey" label="阿里云APPKEY">
				<a-input v-model="setting.ali_appkey" placeholder="请输入阿里云APPKEY" />
			</a-form-model-item>
			<a-form-model-item ref="ali_appsecret" prop="ali_appsecret" label="阿里云APPSECRET">
				<a-input v-model="setting.ali_appsecret" placeholder="请输入阿里云APPSECRET" />
			</a-form-model-item>
			<a-form-model-item ref="sms_sign" prop="sms_sign" label="短信签名">
				<a-input v-model="setting.sms_sign" placeholder="请输入短信签名" />
			</a-form-model-item>
			<a-form-model-item ref="sms_template" prop="sms_template" label="询价通知短信模版编号">
				<a-input v-model="setting.sms_template" placeholder="请输入询价通知短信模版编号" />
			</a-form-model-item>
			<a-divider orientation="left">
				腾讯地图配置
			</a-divider>
			<a-form-model-item ref="qq_key" prop="qq_key" label="腾讯地图KEY">
				<a-input v-model="setting.qq_key" placeholder="请输入腾讯地图KEY" />
			</a-form-model-item>
			<div>
				<a-button type="primary" html-type="submit">
					修改
				</a-button>
			</div>
		</a-form-model>
	</div>
</template>

<script>
	import Func from '../../common/func'
	import AEditor from '../../components/AEditor';
	export default {
		name: 'Setting',
		components: {
			AEditor
		},
		computed: {
			banner_preview() {
				const u = this.setting.lithium_top_banner;
				if (!u) return '';
				return u.indexOf('http') === 0 ? u : Func.pic_url + u;
			}
		},
		data() {
			return {
				form: this.$form.createForm(this),
				setting: {
					ref_exptime: '48',
					phone: '',
					email: '',
					edu_url: '',
					fx_url: '',
					sms_phone: '',
					wx_appid: '',
					wx_appsecret: '',
					ali_appkey: '',
					ali_appcode: '',
					ali_appsecret: '',
					sms_sign: '',
					sms_template: '',
					qq_key: '',
					xj_url2: '',
					xj_url1: '',
					car_gj_img: '',
					car_sel_img: '',
					car_share_info:'',
					wx_tmpl_bid: '',
					wx_tmpl_market: '',
					wx_tmpl_lithium: '',
					getui_app_id: '',
					getui_app_key: '',
					getui_master_secret: '',
					getui_android_packagename: '',
					lithium_top_banner: '',
				},
				rules: {}
			}
		},
		created() {
			this.get_data();
		},
		methods: {
			banner_upload(options) {
				const file = options.file;
				Func.url_form({ action: 'api.ed_upload', imgFile: file }, (res) => {
					if (res.error === 0) {
						this.setting.lithium_top_banner = res.url;
						this.$message.success('宣传图上传成功');
						if (options.onSuccess) options.onSuccess(res);
					} else {
						this.$message.error(res.message || res.info || '上传失败');
						if (options.onError) options.onError(res);
					}
				});
			},
			remove_banner() {
				this.setting.lithium_top_banner = '';
			},
			get_data() {
				Func.url_get({
					action: 'setting.index'
				}, (res) => {
					if (res.error === 0) {
						this.setting = res.info;
					} else {
						this.$message.error(res.info);
					}
				});
			},
			save_data(e) {
				e.preventDefault();
				this.$refs.setting_form.validate(valid => {
					if (valid) {
						Func.url_post({
							action: 'setting.save_data',
							...this.setting
						}, (res) => {
							if (res.error === 0) {
								this.$message.success(res.info);
								this.add_model = false;
								this.get_data();
							} else {
								this.$message.error(res.info);
							}
						});
					} else {
						return false;
					}
				});
			},
			goto_url(url, user_no) {
				this.$router.push({
					path: '/users/' + url,
					params: {
						user_no: user_no
					}
				});
			},
			onCreated(editor) {
				this.editor = Object.seal(editor) // 【注意】一定要用 Object.seal() 否则会报错
			},
			onChange(editor) {
				console.log('onChange', editor.getHtml()) // onChange 时获取编辑器最新内容
			},
		}
	}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss">
</style>
